import { __assign, __extends } from "tslib";
import { DateRange } from 'react-date-range';
import * as moment from 'moment';
import * as React from 'react';
import { getFormattedDateString, getTimePeriodInDays } from '@wix/answers-lib';
import { namespacedClassnames } from '../../common/namespace-classes';
import * as ReactDOM from 'react-dom';
var localeToLangMap = {
    ja: 'jp',
    de: 'de',
    es: 'es',
    ru: 'ru',
    fr: 'fr'
};
export var defaultPredefinedRangeNames = {
    today: 'Today',
    'last-day': 'Last Day',
    '7-days': 'Last 7 Days',
    '30-days': 'Last 30 Days',
    '60-days': 'Last 60 Days',
    '90-days': 'Last 90 Days'
};
var createPredefinedRange = function (rangeSize) {
    return {
        startDate: function (now) { return rangeSize > 0 ? moment(now).subtract(rangeSize, 'days') : now; },
        endDate: function (now) { return rangeSize > 0 ? moment(now).subtract(1, 'days') : now; },
        predefinedRangeClass: "range-size-" + rangeSize,
        rangeSize: rangeSize
    };
};
var validRangeSize = function (rangeSize, minDate, maxDate) {
    var range = createPredefinedRange(rangeSize);
    if (!maxDate && !minDate) {
        return true;
    }
    else {
        var now = moment(Date.now());
        var maxCondition = maxDate ?
            range.endDate(now).startOf('day').valueOf() <= maxDate.startOf('day').valueOf() : true;
        var minCondition = minDate ?
            range.startDate(now).utc().startOf('day').valueOf() >= minDate.utc().startOf('day').valueOf() : true;
        return maxCondition && minCondition;
    }
};
export var DateRangePickerKey = 'date-range-picker';
var DateRangePicker = /** @class */ (function (_super) {
    __extends(DateRangePicker, _super);
    function DateRangePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.calendarTheme = {
            Calendar: { width: 300, color: '#577083', background: '#fcfcfc' },
            PredefinedRangesItem: {
                background: '#ffffff', color: '#445868', fontSize: 14, paddingTop: 8, paddingBottom: 8, paddingLeft: 12, margin: 0
            },
            PredefinedRangesItemActive: { background: '#f2f8fd', color: '#445868' },
            MonthAndYear: { fontWeight: 300, fontSize: 16, marginTop: 5, marginBottom: 5 },
            Weekday: { fontWeight: 500, fontSize: 16, marginTop: 5 },
            DaySelected: { background: '#50e3c2' },
            DayInRange: { color: '#fcfcfc', background: '#577083' },
            MonthButton: { background: '#fcfcfc', color: '#445868' },
        };
        _this.state = {
            dates: {
                startDate: getFormattedDateString(_this.props.value.startDate),
                endDate: getFormattedDateString(_this.props.value.endDate)
            },
            prevStartDate: '',
            prevEndDate: ''
        };
        _this.rangeNames = __assign(__assign({}, defaultPredefinedRangeNames), _this.props.predefinedRangeNames);
        _this.datePickerRef = React.createRef();
        _this.calculatedRanges = {};
        _this.calcPredefinedRanges = function (minDate, maxDate) {
            var _a, _b, _c, _d, _e, _f;
            return (__assign(__assign(__assign(__assign(__assign(__assign({}, (validRangeSize(0, minDate, maxDate) ? (_a = {}, _a[_this.rangeNames.today] = createPredefinedRange(0), _a) : {})), (validRangeSize(1, minDate, maxDate) ? (_b = {}, _b[_this.rangeNames['last-day']] = createPredefinedRange(1), _b) : {})), (validRangeSize(7, minDate, maxDate) ? (_c = {}, _c[_this.rangeNames['7-days']] = createPredefinedRange(7), _c) : {})), (validRangeSize(30, minDate, maxDate) ? (_d = {}, _d[_this.rangeNames['30-days']] = createPredefinedRange(30), _d) : {})), (validRangeSize(60, minDate, maxDate) ? (_e = {}, _e[_this.rangeNames['60-days']] = createPredefinedRange(60), _e) : {})), (validRangeSize(90, minDate, maxDate) ? (_f = {}, _f[_this.rangeNames['90-days']] = createPredefinedRange(90), _f) : {})));
        };
        _this.componentDidMount = function () {
            // this is a hack to know if the selection comes from a predefined value or not
            // ideally it'll come from the library, but it's deprecated and we have a lot on our plate now..
            var node = ReactDOM.findDOMNode(_this.datePickerRef.current);
            node.addEventListener('click', function (e) {
                var parent = e.target && e.target.parentNode;
                if (parent) {
                    var children = Array.from(parent.querySelectorAll('.rdr-PredefinedRangesItem'));
                    var rangesKeyArr = Object.keys(_this.calculatedRanges);
                    var clickedRangeIdx = children.indexOf(e.target);
                    var rangesVal = _this.calculatedRanges[rangesKeyArr[clickedRangeIdx]];
                    _this.lastRangeSelected = rangesVal ? rangesVal.rangeSize : undefined;
                }
            });
        };
        _this.handleChange = function (payload) {
            _this.setState({ dates: payload }, function () {
                var startDate = _this.props.compareModeRangeSize ?
                    _this.props.value.startDate :
                    getFormattedDateString(_this.state.dates.startDate);
                var endDate = _this.props.compareModeRangeSize ?
                    _this.props.value.endDate :
                    getFormattedDateString(_this.state.dates.endDate);
                _this.props.onChange({ startDate: startDate, endDate: endDate, relativePeriod: _this.lastRangeSelected });
                _this.lastRangeSelected = undefined;
            });
        };
        _this.handleComparedDatesChange = function (payload) {
            if (moment(new Date(payload.endDate.toString())).format('YYYY-MM-DD') === _this.state.prevEndDate &&
                moment(new Date(payload.startDate.toString())).format('YYYY-MM-DD') === _this.state.prevStartDate) {
                _this.setState({ dates: payload });
            }
            else if (_this.props.compareModeRangeSize) {
                var updatedEndDate = void 0;
                var updatedEndDateString = void 0;
                if (payload.endDate.format('YYYY-MM-DD') === _this.state.prevStartDate) {
                    updatedEndDate = payload.startDate;
                    updatedEndDateString = moment(new Date(updatedEndDate.toString())).format('YYYY-MM-DD');
                }
                else {
                    updatedEndDate = payload.endDate;
                    updatedEndDateString = moment(new Date(updatedEndDate.toString())).format('YYYY-MM-DD');
                }
                var updatedStartDate = payload.startDate.add(-_this.props.compareModeRangeSize + 1, 'days');
                var updatedStartDateString = moment(new Date(updatedStartDate.toString())).format('YYYY-MM-DD');
                if (getTimePeriodInDays(updatedStartDateString, updatedEndDateString) === _this.props.compareModeRangeSize) {
                    _this.setState({ prevStartDate: updatedStartDateString, prevEndDate: updatedEndDateString });
                    _this.props.onChange({
                        startDate: updatedStartDateString,
                        endDate: updatedEndDateString
                    });
                }
                else {
                    var correctEndDate = payload.endDate;
                    var correctEndDateString = moment(new Date(correctEndDate.toString())).format('YYYY-MM-DD');
                    var correctStartDate = payload.endDate.add(-_this.props.compareModeRangeSize + 1, 'days');
                    var correctStartDateString = moment(new Date(correctStartDate.toString())).format('YYYY-MM-DD');
                    _this.setState({ prevStartDate: correctStartDateString, prevEndDate: correctEndDateString });
                    _this.props.onChange({
                        startDate: correctStartDateString,
                        endDate: correctEndDateString
                    });
                }
            }
        };
        return _this;
    }
    DateRangePicker.prototype.render = function () {
        var maxDate = this.props.maxDate ? moment(this.props.maxDate) : undefined;
        var minDate = this.props.minDate ? moment(this.props.minDate) : undefined;
        var comparedPredefinedRanges = {};
        var isCompareMode = !!this.props.compareModeRangeSize;
        this.calculatedRanges = this.calcPredefinedRanges(minDate, maxDate);
        var ranges = isCompareMode ? comparedPredefinedRanges : this.calculatedRanges;
        var maybeLang = this.props.locale ? localeToLangMap[this.props.locale] : undefined;
        return (React.createElement("div", { className: namespacedClassnames(DateRangePickerKey) },
            React.createElement(DateRange, { ref: this.datePickerRef, startDate: moment(this.props.value.startDate), endDate: moment(this.props.value.endDate), ranges: ranges, onChange: isCompareMode ? this.handleComparedDatesChange : this.handleChange, calendars: 1, format: 'DD-MM-YYYY', theme: this.props.theme || this.calendarTheme, maxDate: maxDate, minDate: minDate, lang: maybeLang })));
    };
    return DateRangePicker;
}(React.PureComponent));
export { DateRangePicker };
//# sourceMappingURL=index.js.map